import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

/**
 * The payline element is used for hold payline special cases and handle payline behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Payline extends SwitchElement {
    // base payline cases
    static CaseSelect: string = "SELECT";

    static CaseNormal: string = "NORMAL";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseSingleCycle: string = "SINGLE_CYCLE";
    static CaseCycle: string = "CYCLE";

    public addTopContainer(cnt: ContainerElement): void {
        cnt.addChild(this.elements.childs["FlowerLeft"]);
        cnt.addChild(this.elements.childs["FlowerRight"]);
        cnt.addChild(this.elements.childs["Mlp"]);
        cnt.addChild(this.elements.childs["Value"]);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Payline.ts
 **/